export const projects = [
    {
        id: 1,
        image: 'https://i.ibb.co/GtnNHTF/mediahub.png',
        image2: 'https://i.ibb.co/HKfnqnn/mediahub2.png',
        title: 'Mediahub',
        sub_title: 'Movie info website',
        body: 'This web application has been created using React, Tailwind, and Redux. I have used API from The Movie Database (TMDB). It provides free data of movies and tv series. In this app viewer can get details info about movie/ tv series. I also added functionality of streaming trailer from youtube. in the home page carousel has been added using react-slick. And routing has been done via react-router-dom. Although this app is not large enough to implement Redux, still I used Redux to demonstrate my capability to work with Redux.',
        tech: ['react', 'redux', 'tailwind'],
        git: 'https://github.com/mdSindabad/movie-app',
        live: 'https://mediahub.netlify.app'
    },
    {
        id: 2,
        image: 'https://i.ibb.co/wyrPdS4/sunglass-garden.png',
        image2: 'https://i.ibb.co/Bt1wPRg/sunglass-garden2.png',
        title: 'Sunglass Garden',
        sub_title: 'Niche Online Store',
        body: 'This web application is a simple niche online store. It contains login/registration system using firebase auth. Data is stored on MongoDB database and backend has been built via nodejs and express. Order can be managed by admin from the dashboard.',
        tech: ['react', 'contextAPI', 'materialUi', 'firebaseAuth', 'nodejs', 'mongoDB'],
        git: 'https://github.com/mdSindabad/sunglass-garden-front-end',
        live: 'https://sunglass-garden.web.app/'
    },
    {
        id: 3,
        image: 'https://i.ibb.co/V2KnHT4/travel.png',
        image2: 'https://i.ibb.co/6yqkFqt/travel2.png',
        title: 'Paradise Travel',
        sub_title: 'Tour website',
        body: 'This web application is a simple travel booking website. It contains login/registration system using firebase auth. Data is stored on MongoDB database and backend has been built via nodejs and express. Order can be managed by admin from the dashboard.',
        tech: ['react', 'contextAPI', 'bootstrap', 'firebaseAuth', 'nodejs', 'mongoDB'],
        git: 'https://github.com/mdSindabad/paradise-tour-front-end',
        live: 'https://paradise-travel-a0dc7.web.app'
    }
]